/**
 * Estimate Unit Types
 */
export enum UsageEstimateItemUnitType {
  Hours = "Hours",
  Days = "Days",
  Count = "Count",
}
